import _ from 'lodash';
import {connect} from 'react-redux';

import {ChannelTypesEnum} from '../../../../../libs/shared/core/src/models/api/channelCommonTypes';
import {ChannelModel} from '../../../../../libs/shared/core/src/models/api/channelModel';
import {parseContactUid} from '../../../../../libs/shared/core/src/models/api/contactModel';
import {compareName} from '../../../../../srcCommon/helpers/localeHelpers';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {mapChannelToChannelType} from '../../../../helpers/models/channelHelpers';
import {CardModel} from '../../../../models/api/cardModel';
import {VisualContactModel} from '../../../../models/api/visualContactModel';
import {AppState} from '../../../../store/appState';
import {makeGetComposeChannels} from '../../../../store/data/channels/channelsSelectors';
import {contactCardComposeMessageForChannelTypeAction} from '../../../../store/panels/contacts/contactCard/contactCardPanelActions';
import {ContactCardFooterComposeMessageAction} from './contactCardFooterComposeMessageAction';

/*
 * Props.
 */

interface ContactCardFooterComposeMessageActionContainerProps {
  card?: CardModel;
  visualContact: VisualContactModel;
}

/*
 * Selectors.
 */

function getCard(_state: AppState, props: ContactCardFooterComposeMessageActionContainerProps) {
  return props.card;
}

function getVisualContact(_state: AppState, props: ContactCardFooterComposeMessageActionContainerProps) {
  return props.visualContact;
}

function makeGetSortedChannelTypes() {
  return createSelector(
    [
      getCard,
      getVisualContact,
      makeGetComposeChannels<ContactCardFooterComposeMessageActionContainerProps>({}),
    ],
    (card: CardModel | undefined, visualContact: VisualContactModel, channels: ReadonlyArray<ChannelModel>) =>
      _(card?.contactUids ?? [visualContact.contact.uid])
        .map((contactUid) => parseContactUid(contactUid)[0])
        .map((source) =>
          channels.map((channel) => {
            if (!channel.behaviors.supportedContactSources.includes(source)) {
              return undefined;
            }
            return mapChannelToChannelType(channel);
          }),
        )
        .flatten()
        .compact()
        .sort((a, b) => compareName(a, b))
        .uniq()
        .value(),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactCardFooterComposeMessageActionContainerProps>()(() => ({
  sortedChannelTypes: makeGetSortedChannelTypes(),
}));

const mapDispatchToProps = makeMapDispatchToProps<ContactCardFooterComposeMessageActionContainerProps>()(
  ({card, visualContact}) => ({
    onComposeMessage: (channelType: ChannelTypesEnum) =>
      contactCardComposeMessageForChannelTypeAction(channelType, visualContact, card),
  }),
);

export const ContactCardFooterComposeMessageActionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactCardFooterComposeMessageAction);
